import { useContext } from 'react';
import _ from 'underscore';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { isAudience, isCTVCampaign, isDealCampaign } from '../../../step-constants';
import { defaultNativeAdGroup, defaultDealAdGroup, defaultCTVAdGroup } from './default-adgroup';

const useDefaultAdGroupForFlow = (flow) => {
  if (isAudience(flow)) {
    return defaultNativeAdGroup;
  }

  if (isDealCampaign(flow)) {
    return defaultDealAdGroup;
  }

  if (isCTVCampaign(flow)) {
    return defaultCTVAdGroup;
  }

  return {};
};

export const useDefaultAdGroup = (flow) => {
  const i18n = useContext(I18nContext);
  const serverContext = useContext(ServerContext);

  const {
    getDefaultAdGroup = _.noop,
    defaultProperties,
    setCustomProperties = _.noop,
    defaultTargetingProperties,
    setCustomTargetingProperties = _.noop,
  } = useDefaultAdGroupForFlow(flow) || {};

  const defaultAdGroupModel = getDefaultAdGroup(i18n, serverContext);
  const { data: defaultAdGroupData } = defaultAdGroupModel || {};

  const defaultAdGroup = _.pick(defaultAdGroupData, defaultProperties);
  setCustomProperties(defaultAdGroup);

  const defaultTargeting = _.pick(defaultAdGroupData, defaultTargetingProperties);
  setCustomTargetingProperties(defaultTargeting);

  return {
    defaultAdGroup,
    defaultTargeting,
  };
};
